import ModelTitleSummary from '../components/summary_section/ModelTitleSummary';
import { IEMPicker } from '../components/name_and_price_section/IEMPicker';
import InTheBoxPreview from '../components/summary_section/InTheBoxPreview';
import IEMPreview from '../components/iem_preview_section/IEMPreview';
import IEMSections from '../components/category_list/IEMSections';
import SettingsSection from '../components/settings_section/SettingsSection';

import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { debounce } from '@material-ui/core';
import OrderDetailScrollable from '../components/summary_section/OrderDetailsScrollable';
import ChoiceList from '../components/ChoiceList';
import { RESIZE_DEBOUNCE_DELAY } from '../constants';
import styles from '../styles/layout.module.css';
import layout from '../styles/layout.module.css';
import { CartActions } from '../components/summary_section/CartActions';

const MobileLayout = (props) => {
    const previewRef = useRef(null);
    // const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 0
    });

    const currentCategory = useSelector(
        (state) => state.rootReducer.currentCategory.activeCategory
    );
    const resizeCanvas = () => {
        // setWindowWidth(window.innerWidth);
        const previewBoxDimensions = previewRef.current?.getBoundingClientRect();
        setDimensions(previewBoxDimensions);
    };

    useEffect(() => {
        setDimensions(previewRef.current.getBoundingClientRect());
    }, []);

    useEffect(() => {
        resizeCanvas();
        const debouncedResize = debounce(resizeCanvas, RESIZE_DEBOUNCE_DELAY);
        window.addEventListener('resize', debouncedResize);
        return () => {
            window.removeEventListener('resize', debouncedResize);
        };
    }, [previewRef]);

    return (
        <Box
            className={
                currentCategory === 'Summary' ? styles.gridContainerSummary : styles.gridContainer
            }>
            <Box className={layout.modelPickerContainer}>
                {currentCategory === 'Summary' ? (
                    <ModelTitleSummary />
                ) : (
                    <IEMPicker width={props.width} modelList={props} />
                )}
            </Box>
            <Box className={layout.iemPreview} id="iem-preview-id" ref={previewRef}>
                {currentCategory === 'Summary' ? (
                    <InTheBoxPreview
                        width={dimensions.width}
                        height={dimensions.height}
                        layerChanges={props.layerChanges}
                        setLayerChanges={props.setLayerChanges}
                        image={props.blob}
                        onBlob={props.onBlob}
                    />
                ) : (
                    <IEMPreview
                        width={dimensions.width * 0.9}
                        height={dimensions.height * 0.9}
                        layerChanges={props.layerChanges}
                        setLayerChanges={props.setLayerChanges}
                        layers={props.layers}
                        onLoad={props.onLoad}
                        handleLayerChange={props.handleLayerChange}
                    />
                )}
            </Box>
            <Box className={layout.menu}>
                <IEMSections />
            </Box>
            {currentCategory === 'Summary' ? (
                <Box className={layout.iemSummaryDetail}>
                    <OrderDetailScrollable />
                </Box>
            ) : (
                <ChoiceList
                    width={dimensions.width}
                    onMirror={props.onMirror}
                    onFlip={props.onFlip}
                    onReset={props.onReset}
                    onCenter={props.onCenter}
                />
            )}
            {currentCategory !== 'Model' &&
            currentCategory !== 'Finalize' &&
            currentCategory !== 'Summary' ? (
                <Box
                    style={{
                        position: 'fixed',
                        left: '0',
                        width: '100%',
                        bottom: '0',
                        paddingBottom: 'env(safe-area-inset-bottom)',
                        marginBottom: '15px',
                        backgroundColor: 'white'
                    }}>
                    <SettingsSection />
                </Box>
            ) : (
                <> </>
            )}
            {currentCategory === 'Summary' ? (
                <Box
                    style={{
                        position: 'fixed',
                        left: '0',
                        width: '100%',
                        bottom: '0',
                        paddingBottom: 'env(safe-area-inset-bottom)',
                        marginBottom: '10px',
                        backgroundColor: 'white'
                    }}>
                    <CartActions img={props.blob} />
                </Box>
            ) : (
                <></>
            )}
        </Box>
    );
};

export default MobileLayout;
